import CssBaseline from '@mui/material/CssBaseline'
import { Outlet } from '@tanstack/react-router'
import './App.css'
import PageLayout from './components/PageLayout'

function App() {
  return (
    <>
      <CssBaseline enableColorScheme />
      <PageLayout>
        <Outlet />
      </PageLayout>
    </>
  )
}

export default App
